import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./styles.module.css";
import Button from "Root/profile/components/common/Button";
export default function StickyBottom(props) {
    return (_jsx("div", { className: styles.stickybottom, children: _jsx(Button, { onClick: () => props.handleClick(), disabled: props.buttonDisabled, loading: props.loading || undefined, children: props.text }) }));
}
